import { ApplicationSummaryWrapper } from '@/components/modules/Application/components/_shared/components/ApplicationSummary/ApplicationSummaryWrapper';
import { ApplicationRestart } from '@/components/modules/Application/components/_shared/components/ApplicationSummary/components/ApplicationRestart';
import { ApplicationSteps } from '@/components/modules/Application/Default/ApplicationSteps';
import { useApplicationNavigation } from '@/components/modules/Application/hooks/useApplicationNavigation';
import { ApplicationStep } from '@/components/modules/Application/types/ApplicationStep';

export const DefaultApplication = () => {
  const { step } = useApplicationNavigation();

  return (
    <>
      <ApplicationSummaryWrapper>
        <ApplicationSteps />
      </ApplicationSummaryWrapper>
      {step && step !== ApplicationStep.AGENT_SELECTION && <ApplicationRestart />}
    </>
  );
};
